import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PaginationCustom from "../../components/Pagination";
import { getRefuelingHistoryByVehicle } from "../../store/Slices/FuelSlice";
import "../../styles/Trip.css";
import { formatDate } from "../../utils/helper";
import SpinnerLoader from "../../utils/SpinnerLoader";
import { viewIcon } from "../../utils/svgs";

const RefuelingHistory = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate();

    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const { getRefuelingHistoryByVehicleData, getRefuelingHistoryByVehicleLoading } = useSelector((state) => state.fuel);

    console.log(getRefuelingHistoryByVehicleData)

    useEffect(() => {
        const data = {
            page: currentPage,
            limit: limit,
            vehicle_id: id,
        }

        dispatch(getRefuelingHistoryByVehicle(data));
    }, [currentPage, limit])

    if (getRefuelingHistoryByVehicleLoading) {
        return <SpinnerLoader />;
    }

    return (
        <div className="violations_wrap">
            <div className="violations_table_card">
                <div className="violations_table">
                    <div className="violations_head refueling_history_head">
                        <span>Trip ID</span>
                        <span>Timestamp</span>
                        <span>Station Name</span>
                        <span>Liters Filled</span>
                        <span>Cost (PKR)</span>
                        <span>Cost/Liter (PKR)</span>
                        {/* <span>Reconciliation Status</span> */}
                        <span>View</span>
                    </div>
                    {getRefuelingHistoryByVehicleData?.results?.map((row, index) => (
                        <div className="violations_row refueling_history_row" key={row.sr}>
                            <span>{row?.trip_info?.trip_id}</span>
                            <span>{formatDate(row.refuel_at)}</span>
                            <span>
                                <strong>{row?.fuel_station?.name}</strong>
                            </span>
                            <span>{row?.claimed_fueled}</span>
                            <span>{row?.total_fuel_cost}</span>
                            <span>{(row?.total_fuel_cost / row?.claimed_fueled).toFixed(2)}</span>
                            <span onClick={() => navigate(`/trips/${row?.trip_info?.id}`)}>{viewIcon}</span>
                        </div>
                    ))}

                    <PaginationCustom
                        className="violation_pagination"
                        totalItems={getRefuelingHistoryByVehicleData?.meta?.totalItems}
                        totalPages={getRefuelingHistoryByVehicleData?.meta?.totalPages}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        limit={limit}
                        setLimit={setLimit}
                    />
                </div>
            </div>
        </div>
    );
};

export default RefuelingHistory;
